import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Directive({
  selector: '[appCurrencyInput]',
  standalone: true,
  providers: [CurrencyPipe]
})
export class CurrencyInputDirective implements OnInit {
  @Input() appCurrency: string = 'USD';
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef, private renderer: Renderer2, private currencyPipe: CurrencyPipe) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit(): void {
    this.formatValue(this.el.value);
  }

  @HostListener('focus', ['$event'])
  onFocus(event: any): void {
    const value = this.el.value.replace(/,/g, '');
    this.renderer.setProperty(this.el, 'value', value);
    // Prefilled amount: select it so typing replaces it (same as appMoney).
    setTimeout(() => { if (document.activeElement === this.el) this.el.select(); });
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any): void {
    const value = parseFloat(this.el.value);
    if (!isNaN(value)) {
      this.formatValue(value);
    }
  }

  private formatValue(value: any): void {
    const formattedValue = this.currencyPipe.transform(value, this.appCurrency);
    this.renderer.setProperty(this.el, 'value', formattedValue);
  }
}
